import React, { useState, useEffect, useRef } from "react";
import { FiPlus, FiFileText, FiEdit, FiX, FiDollarSign, FiCalendar, FiAlignLeft, FiHash } from "react-icons/fi";
import { baseurl } from "../../baseurl";
import axios from "axios";
import Swal from "sweetalert2";
import Select from "react-select";
import 'jquery-ui/themes/base/all.css';
import 'jquery-ui/ui/widgets/datepicker';
import $ from "jquery";
import { FaRupeeSign } from "react-icons/fa";

/* ─── CSS ─── */
const CSS = `
@import url('https://fonts.googleapis.com/css2?family=Sora:wght@400;600;700;800&family=DM+Sans:wght@400;500;600&display=swap');

/* ── overlay ── */
.acn__overlay {
  position: fixed; inset: 0; z-index: 1050;
  background: rgba(6, 32, 32, 0.45);
  backdrop-filter: blur(6px);
  display: flex; align-items: center; justify-content: center;
  padding: 20px;
  animation: acn__fadeIn 0.2s ease both;
}
@keyframes acn__fadeIn  { from{opacity:0} to{opacity:1} }
@keyframes acn__slideUp { from{opacity:0;transform:translateY(24px) scale(0.98)} to{opacity:1;transform:translateY(0) scale(1)} }
@keyframes acn__spin    { to{transform:rotate(360deg)} }
@keyframes acn__shimmer { 0%{background-position:-400px 0} 100%{background-position:400px 0} }

/* ── modal box ── */
.acn__modal {
  width: 100%; max-width: 500px;
  background: #fff;
  border-radius: 24px;
  border: 1px solid rgba(10,85,86,0.12);
  box-shadow: 0 0 0 1px rgba(10,85,86,0.06), 0 12px 40px rgba(10,85,86,0.14), 0 32px 80px rgba(0,0,0,0.14), inset 0 1px 0 #fff;
  overflow: hidden;
  animation: acn__slideUp 0.28s cubic-bezier(0.34,1.36,0.64,1) both;
  font-family: 'DM Sans', sans-serif;
  position: relative;
}

/* top accent bar */
.acn__modal::before {
  content: '';
  position: absolute; top: 0; left: 0; right: 0; height: 4px;
  background: linear-gradient(90deg, #0a5556 0%, #14b8a6 55%, #FFD166 100%);
  border-radius: 24px 24px 0 0;
}

/* ── header ── */
.acn__hd {
  display: flex; align-items: center; justify-content: space-between;
  padding: 24px 26px 18px;
  border-bottom: 1px solid rgba(10,85,86,0.08);
}
.acn__hd-left  { display: flex; align-items: center; gap: 12px; }
.acn__hd-icon {
  width: 42px; height: 42px; border-radius: 13px; flex-shrink: 0;
  display: flex; align-items: center; justify-content: center; font-size: 18px;
  color: #fff;
}
.acn__hd-icon--new  { background: linear-gradient(135deg, #0a5556, #14b8a6); box-shadow: 0 4px 14px rgba(10,85,86,0.30); }
.acn__hd-icon--edit { background: linear-gradient(135deg, #0c7172, #FFD166); box-shadow: 0 4px 14px rgba(12,113,114,0.28); }
.acn__hd-title {
  font-family: 'Sora', sans-serif; font-size: 17px; font-weight: 800;
  color: #062020; letter-spacing: -0.03em; margin: 0 0 2px;
}
.acn__hd-sub { font-size: 12px; color: #5a8080; margin: 0; }

.acn__close-btn {
  width: 34px; height: 34px; border-radius: 10px; border: none;
  background: rgba(10,85,86,0.06); cursor: pointer;
  display: flex; align-items: center; justify-content: center;
  color: #5a8080; font-size: 15px;
  transition: background 0.16s, color 0.16s;
  flex-shrink: 0;
}
.acn__close-btn:hover { background: rgba(10,85,86,0.12); color: #0a5556; }

/* ── body ── */
.acn__body { padding: 22px 26px; display: flex; flex-direction: column; gap: 16px; }

/* label */
.acn__lbl {
  display: flex; align-items: center; gap: 6px;
  font-size: 11px; font-weight: 700; color: #132b2b;
  margin-bottom: 6px; letter-spacing: 0.06em; text-transform: uppercase;
}
.acn__lbl-dot { width: 5px; height: 5px; border-radius: 50%; background: #0a5556; flex-shrink: 0; }

/* input */
.acn__input {
  width: 100%; padding: 11px 14px;
  font-size: 13.5px; font-family: 'DM Sans', sans-serif; color: #0a2020;
  background: #f3fafa; border: 1.5px solid #c8e4e4; border-radius: 12px;
  outline: none; box-sizing: border-box;
  transition: border-color 0.18s, box-shadow 0.18s, background 0.18s;
}
.acn__input:focus { border-color: #0a5556; background: #fff; box-shadow: 0 0 0 4px rgba(10,85,86,0.09); }
.acn__input::placeholder { color: #9ababa; }

/* input with icon */
.acn__field-wrap { position: relative; }
.acn__field-icon {
  position: absolute; left: 12px; top: 50%; transform: translateY(-50%);
  color: #7aadad; font-size: 14px; pointer-events: none;
}
.acn__field-icon--top { top: 14px; transform: none; }
.acn__input--icon  { padding-left: 36px; }

/* textarea */
.acn__textarea {
  width: 100%; padding: 11px 14px 11px 36px;
  font-size: 13.5px; font-family: 'DM Sans', sans-serif; color: #0a2020;
  background: #f3fafa; border: 1.5px solid #c8e4e4; border-radius: 12px;
  outline: none; resize: vertical; min-height: 88px; box-sizing: border-box;
  transition: border-color 0.18s, box-shadow 0.18s, background 0.18s;
}
.acn__textarea:focus { border-color: #0a5556; background: #fff; box-shadow: 0 0 0 4px rgba(10,85,86,0.09); }
.acn__textarea::placeholder { color: #9ababa; }

/* 2-col grid */
.acn__grid2 { display: grid; grid-template-columns: 1fr 1fr; gap: 14px; }

/* react-select overrides */
.acn__select .acn-rs__control {
  background: #f3fafa !important;
  border: 1.5px solid #c8e4e4 !important;
  border-radius: 12px !important;
  min-height: 42px !important;
  box-shadow: none !important;
  font-family: 'DM Sans', sans-serif !important;
  font-size: 13.5px !important;
}
.acn__select .acn-rs__control--is-focused {
  border-color: #0a5556 !important;
  background: #fff !important;
  box-shadow: 0 0 0 4px rgba(10,85,86,0.09) !important;
}
.acn__select .acn-rs__placeholder { color: #9ababa !important; }
.acn__select .acn-rs__single-value { color: #0a2020 !important; }
.acn__select .acn-rs__menu {
  border-radius: 12px !important;
  border: 1.5px solid rgba(10,85,86,0.14) !important;
  box-shadow: 0 8px 28px rgba(10,85,86,0.12) !important;
  overflow: hidden !important;
  font-family: 'DM Sans', sans-serif !important;
  font-size: 13.5px !important;
}
.acn__select .acn-rs__option--is-focused  { background: rgba(10,85,86,0.07) !important; color: #0a5556 !important; }
.acn__select .acn-rs__option--is-selected { background: #0a5556 !important; color: #fff !important; }
.acn__select .acn-rs__indicator-separator { background: #c8e4e4 !important; }
.acn__select .acn-rs__dropdown-indicator  { color: #7aadad !important; }
.acn__select .acn-rs__clear-indicator:hover { color: #ef4444 !important; }

/* ── invoice info preview ── */
.acn__inv-preview {
  display: flex; align-items: center; gap: 10px;
  background: rgba(10,85,86,0.05); border: 1px solid rgba(10,85,86,0.12);
  border-radius: 11px; padding: 10px 14px;
  animation: acn__fadeIn 0.2s ease both;
}
.acn__inv-preview-dot { width: 8px; height: 8px; border-radius: 50%; background: #14b8a6; flex-shrink: 0; }
.acn__inv-preview-text { font-size: 12.5px; font-weight: 600; color: #0a5556; }
.acn__inv-preview-amt  { margin-left: auto; font-family: 'Sora', sans-serif; font-size: 13px; font-weight: 800; color: #0a5556; }

/* ── footer ── */
.acn__footer {
  display: flex; align-items: center; justify-content: flex-end; gap: 10px;
  padding: 16px 26px 22px;
  border-top: 1px solid rgba(10,85,86,0.08);
}
.acn__cancel-btn {
  padding: 10px 20px; border-radius: 11px;
  font-size: 13.5px; font-family: 'Sora', sans-serif; font-weight: 700;
  color: #5a8080; background: rgba(10,85,86,0.06);
  border: 1.5px solid rgba(10,85,86,0.14); cursor: pointer;
  transition: background 0.16s, color 0.16s, border-color 0.16s;
}
.acn__cancel-btn:hover { background: rgba(10,85,86,0.10); color: #0a5556; border-color: rgba(10,85,86,0.22); }

.acn__submit-btn {
  padding: 10px 26px; border-radius: 11px;
  font-size: 13.5px; font-family: 'Sora', sans-serif; font-weight: 700;
  color: #fff; letter-spacing: 0.03em;
  background: linear-gradient(135deg, #0a5556 0%, #0c7172 50%, #14b8a6 100%);
  background-size: 200% auto;
  border: none; cursor: pointer;
  box-shadow: 0 4px 18px rgba(10,85,86,0.32);
  transition: background-position 0.4s, transform 0.14s, box-shadow 0.18s;
  position: relative; overflow: hidden;
  display: flex; align-items: center; gap: 7px;
}
.acn__submit-btn::after {
  content: ''; position: absolute; inset: 0;
  background: linear-gradient(90deg,transparent,rgba(255,255,255,0.14),transparent);
  background-size: 400px 100%; opacity: 0; transition: opacity 0.3s;
}
.acn__submit-btn:hover { background-position: right center; transform: translateY(-1px); box-shadow: 0 8px 26px rgba(10,85,86,0.38); }
.acn__submit-btn:hover::after { opacity: 1; animation: acn__shimmer 1.1s linear infinite; }
.acn__submit-btn:active { transform: translateY(0); }
.acn__submit-btn:disabled { opacity: 0.62; cursor: not-allowed; transform: none !important; }

.acn__spin {
  width: 13px; height: 13px; border: 2px solid rgba(255,255,255,0.3);
  border-top-color: #fff; border-radius: 50%;
  animation: acn__spin 0.7s linear infinite; flex-shrink: 0;
}

/* ── trigger button ── */
.acn__trigger-btn {
  display: inline-flex; align-items: center; gap: 8px;
  padding: 10px 20px; border-radius: 12px;
  font-size: 13.5px; font-family: 'Sora', sans-serif; font-weight: 700;
  color: #fff; letter-spacing: 0.03em;
  background: linear-gradient(135deg, #0a5556, #14b8a6);
  border: none; cursor: pointer;
  box-shadow: 0 4px 16px rgba(10,85,86,0.30);
  transition: transform 0.14s, box-shadow 0.18s;
}
.acn__trigger-btn:hover { transform: translateY(-1px); box-shadow: 0 8px 24px rgba(10,85,86,0.36); }
.acn__trigger-btn:active { transform: translateY(0); }

@media(max-width: 520px) {
  .acn__grid2 { grid-template-columns: 1fr; }
  .acn__modal { border-radius: 18px; }
}
`;

function AddCreditNote({ onSuccess, editData, clearEdit }) {
  const token = localStorage.getItem("auth_token");

  const [showModal, setShowModal]           = useState(false);
  const [saving, setSaving]                 = useState(false);
  const [invoices, setInvoices]             = useState([]);
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [creditData, setCreditData]         = useState({
    invoice_id: "",
    credit_amount: "",
    reason: "",
    date: new Date().toISOString().split("T")[0],
  });

  const dateInputRef = useRef(null);

  const Toast = Swal.mixin({
    toast: true, position: "top-end",
    showConfirmButton: false, timer: 2500,
  });

  /* ── handle incoming editData (unchanged) ── */
  useEffect(() => {
    if (editData) {
      setCreditData({
        id: editData.id,
        invoice_id: editData.invoice_id,
        credit_amount: editData.credit_amount,
        reason: editData.reason || "",
        date: editData.credit_date || new Date().toISOString().split("T")[0],
      });
      setShowModal(true);
    }
  }, [editData]);

  /* ── fetch invoices (unchanged) ── */
  useEffect(() => {
    if (!showModal) return;
    const fetchInvoices = async () => {
      try {
        const res = await axios.get(`${baseurl}getAllInvoicesByBusiness`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (res.data.success) {
          const list = res.data.data || [];
          setInvoices(list);
          if (creditData.invoice_id) {
            const current = list.find(inv => String(inv.id) === String(creditData.invoice_id));
            if (current) setSelectedInvoice(current);
          }
        }
      } catch (err) { console.error(err); }
    };
    fetchInvoices();
  }, [showModal, token, creditData.invoice_id]);

  /* ── datepicker (unchanged) ── */
  useEffect(() => {
    if (showModal && dateInputRef.current) {
      $(dateInputRef.current).datepicker({
        dateFormat: "yy-mm-dd",
        onSelect: (dateText) => setCreditData(prev => ({ ...prev, date: dateText })),
      });
    }
  }, [showModal]);

  const closeModal = () => {
    setShowModal(false);
    if (clearEdit) clearEdit();
    setSelectedInvoice(null);
    setCreditData({
      invoice_id: "", credit_amount: "", reason: "",
      date: new Date().toISOString().split("T")[0],
    });
  };

  /* ── submit (unchanged) ── */
  const handleSubmit = async () => {
    if (!creditData.invoice_id || !creditData.credit_amount) {
      Toast.fire({ icon: "error", title: "Missing fields" }); return;
    }
    try {
      setSaving(true);
      const endpoint = editData ? "updateCreditNote" : "addCreditNote";
      console.log("📤 Credit Note API Call");
      console.log("Endpoint:", endpoint);
      console.log("Payload:", creditData);
      const res = await axios.post(
        `${baseurl}${endpoint}`, creditData,
        { headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" } }
      );
      console.log("📥 Credit Note API Response:", res.data);
      Toast.fire({ icon: "success", title: res.data?.message || "Success" });
      closeModal();
      if (onSuccess) onSuccess();
    } catch (err) {
      console.error("❌ Credit Note API Error:", err);
      Toast.fire({ icon: "error", title: err?.response?.data?.message || "Operation failed" });
    } finally {
      setSaving(false);
    }
  };

  const isEdit = !!editData;

  return (
    <>
      <style>{CSS}</style>

      {/* Trigger button */}
      <button className="acn__trigger-btn" onClick={() => setShowModal(true)}>
        <FiPlus size={15} /> Create Credit Note
      </button>

      {/* Modal */}
      {showModal && (
        <div className="acn__overlay" onClick={(e) => { if (e.target === e.currentTarget) closeModal(); }}>
          <div className="acn__modal">

            {/* Header */}
            <div className="acn__hd">
              <div className="acn__hd-left">
                <div className={`acn__hd-icon ${isEdit ? "acn__hd-icon--edit" : "acn__hd-icon--new"}`}>
                  {isEdit ? <FiEdit size={18} /> : <FiFileText size={18} />}
                </div>
                <div>
                  <div className="acn__hd-title">{isEdit ? "Edit Credit Note" : "New Credit Note"}</div>
                  <div className="acn__hd-sub">{isEdit ? "Update the details below" : "Fill in the details to issue a credit note"}</div>
                </div>
              </div>
              <button className="acn__close-btn" onClick={closeModal}><FiX /></button>
            </div>

            {/* Body */}
            <div className="acn__body">

              {/* Invoice select */}
              <div>
                <div className="acn__lbl"><div className="acn__lbl-dot" />Select Invoice</div>
                <Select
                  className="acn__select"
                  classNamePrefix="acn-rs"
                  placeholder="Search invoice number…"
                  options={invoices.map(inv => ({
                    value: inv.id,
                    label: `${inv.invoice_number} — ₹${inv.invoice_data?.grandTotal ?? "—"}`,
                  }))}
                  value={selectedInvoice
                    ? { value: selectedInvoice.id, label: `${selectedInvoice.invoice_number} — ₹${selectedInvoice.invoice_data?.grandTotal ?? "—"}` }
                    : null
                  }
                  onChange={(opt) => {
                    const inv = invoices.find(i => String(i.id) === String(opt?.value));
                    setSelectedInvoice(inv || null);
                    setCreditData(p => ({ ...p, invoice_id: opt?.value || "" }));
                  }}
                  isClearable
                />
                {/* Invoice preview pill */}
                {selectedInvoice && (
                  <div className="acn__inv-preview" style={{ marginTop: 8 }}>
                    <div className="acn__inv-preview-dot" />
                    <span className="acn__inv-preview-text">{selectedInvoice.invoice_number}</span>
                    <span className="acn__inv-preview-amt">₹{selectedInvoice.invoice_data?.grandTotal ?? "—"}</span>
                  </div>
                )}
              </div>

              {/* Amount + Date */}
              <div className="acn__grid2">
                <div>
                  <div className="acn__lbl"><div className="acn__lbl-dot" />Credit Amount</div>
                  <div className="acn__field-wrap">
                    <FaRupeeSign className="acn__field-icon" />
                    <input
                      type="number"
                      className="acn__input acn__input--icon"
                      placeholder="0.00"
                      value={creditData.credit_amount}
                      onChange={(e) => setCreditData(p => ({ ...p, credit_amount: e.target.value }))}
                    />
                  </div>
                </div>
                <div>
                  <div className="acn__lbl"><div className="acn__lbl-dot" />Credit Note Date</div>
                  <div className="acn__field-wrap">
                    <FiCalendar className="acn__field-icon" />
                    <input
                      type="text"
                      className="acn__input acn__input--icon"
                      ref={dateInputRef}
                      value={creditData.date}
                      readOnly
                    />
                  </div>
                </div>
              </div>

              {/* Reason */}
              <div>
                <div className="acn__lbl"><div className="acn__lbl-dot" />Reason <span style={{ fontSize: 9, color: "#9ababa", fontWeight: 600, textTransform: "none", letterSpacing: 0, marginLeft: 6, background: "rgba(10,85,86,0.06)", border: "1px solid #c8e4e4", borderRadius: 50, padding: "1px 7px" }}>Optional</span></div>
                <div className="acn__field-wrap">
                  <FiAlignLeft className="acn__field-icon acn__field-icon--top" />
                  <textarea
                    className="acn__textarea"
                    placeholder="Describe the reason for issuing this credit note…"
                    rows="3"
                    value={creditData.reason}
                    onChange={(e) => setCreditData(p => ({ ...p, reason: e.target.value }))}
                  />
                </div>
              </div>

            </div>

            {/* Footer */}
            <div className="acn__footer">
              <button className="acn__cancel-btn" onClick={closeModal}>Cancel</button>
              <button className="acn__submit-btn" onClick={handleSubmit} disabled={saving}>
                {saving
                  ? <><div className="acn__spin" />{isEdit ? "Updating…" : "Saving…"}</>
                  : <>{isEdit ? <FiEdit size={13} /> : <FiPlus size={13} />}{isEdit ? "Update Note" : "Create Note"}</>
                }
              </button>
            </div>

          </div>
        </div>
      )}
    </>
  );
}

export default AddCreditNote;
